import axios from 'axios';
import { getSession } from '../utils/SessionUtils'; // adjust path if needed
import { apiCall } from '../utils/ApiUtils';

const BASE_URL = process.env.REACT_APP_INVENTORY_BASE_URL;
const companyCode= getSession("COMPANY")

export const saveInventory = async (inventory, imageFile, additionalImages,company) => {
  const formData = new FormData();
  inventory.companyCode= companyCode;
  formData.append('inventory', new Blob([JSON.stringify(inventory)], { type: 'application/json' }));
  if (imageFile) {
    formData.append('image', imageFile);  
  }
  // Only append additionalImages if they exist
  if (additionalImages && additionalImages.length > 0) {
    additionalImages.forEach((file) => {
      formData.append('additionalImages', file);
    });
  }
  try {
    const response = await apiCall("POST",
      `${BASE_URL}/${companyCode}/saveInventoryItem`,
      formData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Fetch all inventory items for a company
export const findAllInventoryItems = async (company) => {
  try {
    const response = await apiCall("GET",
      `${BASE_URL}/${companyCode}/findAllInventoryItems`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Upload Excel file for inventory bulk import
export const uploadInventoryExcel = async (file, company ) => {
  const formData = new FormData();
  formData.append('file', file);
  try {
    const response = await apiCall("POST",
      `${BASE_URL}/${companyCode}/uploadExcel`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }
    );
    console.log("Excel upload response::::>", response);
    // Return response with status and data
    return {
      success: true,
      status: response.status,
      message: response.data
    };
  } catch (error) {
    // Return error response with status and message
    console.error(error.response);
    return {
      success: false,
      status: error.response?.status,
      message: error.response?.data || error.message
    };
  }
};


//filterInventoryItems
export const filterInventoryItems = async (filter) => {
  const url =`${BASE_URL}/${companyCode}/filterInventoryItems`;
  try {
    const response = await apiCall("POST",
      url,
      filter
    );
    return response;
  } catch (error) {
    throw error;
  }
};

//@PostMapping("/{company}/deleteInventory/{sku}")
export const deleteInventoryItem = async (sku, company) => {
  const url =`${BASE_URL}/${companyCode}/deleteInventory/${sku}`;
  try {
    const response = await apiCall("POST",
      url
    );
    return response;
  } catch (error) {
    throw error;
  }
};